import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';



const DeleteAlbumModal = ({
    closeModal, 
    handleDeleteAlbum,  
    deleteAlbumDataModal, 
    deleteAlbumResult,
    deleteAlbumMessage,
    deleteAlbumMessageError
}) => {

  const [albumName, setAlbumName] = useState('');

  const handleChange = event => {
    setAlbumName(event.target.value);

  };

  // const handleDeleteAlbum = () => {
  //   console.log('handleSaveAlbum()');

  //   console.log(`album id: ${albumId}`)

  //   handleDeleteAlbum(albumId);
  //   closeModal(false);
  // };

  return (
    <Wrapper>
      <Container>
        <CloseBtn onClick={()=>closeModal(false)}><HighlightOffIcon sx={{ fontSize: 30 }}/></CloseBtn>
        {
          !deleteAlbumResult ? 
            <ModalContent>
              <Title>Are you sure to delete the <span>PictureViewer</span> album "{deleteAlbumDataModal.album_name}"?</Title>
            
              {/* {createAlbumMessage && <Message>{createAlbumMessage}</Message>} */}
              <ButtonsWrapper>
                <CancelBtn onClick={()=>closeModal(false)}>no</CancelBtn>
                <DeleteBtn onClick={()=>handleDeleteAlbum(deleteAlbumDataModal.album_id)}>yes</DeleteBtn>
              </ButtonsWrapper>
              <Note>
                The album will be definitivly deleted, but you will still have the image stored in the recent roll album.
              </Note>
            </ModalContent>
          :
            <ModalContent>
                <Title><span>PictureViewer</span> album "{deleteAlbumDataModal.album_name}"</Title>
              {
                deleteAlbumResult === 'deleted' ?
                  <Message>
                    {deleteAlbumMessage}
                  </Message>
                :
                <ErrorMessage>
                    {deleteAlbumMessageError}
                  </ErrorMessage>
              }
              <CancelBtn onClick={()=>closeModal(false)}>ok</CancelBtn>

            </ModalContent>

            
        }
      </Container>
    </Wrapper>
  )
}

export default DeleteAlbumModal;

const Wrapper = styled.div `

  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .6);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div `
  width: 50%;
  /* height: 50vh; */
  border-radius: 5px;
  background-color: rgba(0, 0, 0, .8);
  border: 1px solid orange;
  padding: .5rem 1rem 4rem;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen AND (max-width: 950px) {
    width: 75%;
  }
  
  @media screen AND (max-width: 415px) {
    width: 100%;
  }
`;

const CloseBtn = styled.div `
  align-self: flex-end;
  cursor: pointer;
`;

const ModalContent = styled.div `
  width: 75%;
  /* border: 1px solid green; */

  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen AND (max-width: 600px) {
    width: 100%;
  }
`;

const Title = styled.div `
  text-transform: capitalize;
  font-size: 1.4rem;

  span {
    color: orange;
  }
`;

const Content = styled.div `
  text-align: center;
  margin-top: 2rem;
  text-transform: capitalize;
  font-size: 1.8rem;
  width: 100%; 

  input {
    padding: .2rem .6rem;
    height: 2.6rem;
    font-size: 1.4rem;
    width: 100%; 
  }

`;

const Note = styled.div `
  margin-top:2rem;
  font-size: 1rem;
  color: #d1d1d1;
  line-height: 1.2rem;
`;

const Message = styled.div `
  font-size: 1rem;
  color: green;
  line-height: 1.6rem;
`;
const ErrorMessage = styled.div `
  font-size: 1rem;
  color: red;
  line-height: 1.6rem;
`;


const ButtonsWrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  font-size: 1.2rem;
  margin-top: 1rem;
  width: 100%;
  text-transform: uppercase;
`;

const CancelBtn = styled.div `
  border: 1px solid orange;
  border-radius: 3px;
  padding: .3rem .6rem;
  cursor: pointer;
`;

const DeleteBtn = styled.div `
  border: 1px solid orange;
  border-radius: 3px;
  padding: .3rem .6rem;
  cursor: pointer;
`;